import { Star, Quote } from 'lucide-react'

const testimonials = [
    {
        name: 'Sarah Chen',
        role: 'Content Marketing Manager',
        company: 'TechFlow',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
        content: 'InkSpot has completely transformed how our team writes. We\'ve cut editing time by 40% and our content feels so much more original.',
        rating: 5,
    },
    {
        name: 'Marcus Johnson',
        role: 'Freelance Copywriter',
        company: 'Self-employed',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
        content: 'As a writer, I was skeptical at first. But the AI suggestions are actually good – they match my voice instead of sounding robotic.',
        rating: 5,
    },
    {
        name: 'Emily Rodriguez',
        role: 'Author',
        company: '3 Published Novels',
        avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
        content: 'I use InkSpot for every manuscript now. It catches things I would have missed, and the Chrome extension is a game-changer for emails.',
        rating: 5,
    },
]

export default function Testimonials() {
    return (
        <section id="testimonials" className="relative py-24 sm:py-32 overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 bg-gradient-to-b from-slate-950 to-slate-900" />

            {/* Decorative Elements */}
            <div className="absolute top-1/2 left-0 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl" />
            <div className="absolute top-1/2 right-0 w-64 h-64 bg-accent-500/10 rounded-full blur-3xl" />

            {/* Content */}
            <div className="relative z-10 section-container">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="section-title">
                        Loved by{' '}
                        <span className="gradient-text">Writers Everywhere</span>
                    </h2>
                    <p className="section-subtitle">
                        Join thousands of writers who've improved their craft with InkSpot.
                    </p>
                </div>

                {/* Testimonials Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className="glass-card-hover p-6 sm:p-8 flex flex-col"
                        >
                            {/* Quote Icon */}
                            <Quote className="w-10 h-10 text-primary-400/30 mb-4" />

                            {/* Content */}
                            <p className="text-white/80 leading-relaxed flex-grow mb-6">
                                "{testimonial.content}"
                            </p>

                            {/* Rating */}
                            <div className="flex gap-1 mb-4">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                                ))}
                            </div>

                            {/* Author */}
                            <div className="flex items-center gap-4">
                                {testimonial.avatar ? (
                                    <img
                                        src={testimonial.avatar}
                                        alt={testimonial.name}
                                        className="w-12 h-12 rounded-full object-cover"
                                    />
                                ) : (
                                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center text-white font-bold">
                                        {testimonial.name.charAt(0)}
                                    </div>
                                )}
                                <div>
                                    <p className="font-semibold text-white">{testimonial.name}</p>
                                    <p className="text-sm text-white/50">{testimonial.role}</p>
                                    <p className="text-xs text-primary-400">{testimonial.company}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Stats Bar */}
                <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
                    {[
                        { value: '10K+', label: 'Active Users' },
                        { value: '2M+', label: 'Clichés Detected' },
                        { value: '4.9', label: 'Average Rating' },
                        { value: '98%', label: 'Satisfaction Rate' },
                    ].map((stat, index) => (
                        <div key={index} className="text-center">
                            <div className="text-3xl sm:text-4xl font-bold gradient-text mb-1">
                                {stat.value}
                            </div>
                            <div className="text-sm text-white/50">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
